var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_239_1",
    "data-name": "Component 239 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15713",
    "data-name": "Group 15713",
    transform: "translate(-96 -786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_7270",
    "data-name": "Path 7270",
    transform: "translate(111.657 795)",
    fill: "#fff",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.004084587097168 7.671660900115967 L 1.167344808578491 7.671660900115967 C 0.7993748188018799 7.671660900115967 0.5000048279762268 7.372270584106445 0.5000048279762268 7.004280567169189 L 0.5000048279762268 1.167380690574646 C 0.5000048279762268 0.7993906736373901 0.7993748188018799 0.5000007152557373 1.167344808578491 0.5000007152557373 L 7.004084587097168 0.5000007152557373 C 7.372055053710938 0.5000007152557373 7.671424865722656 0.7993906736373901 7.671424865722656 1.167380690574646 L 7.671424865722656 7.004280567169189 C 7.671424865722656 7.372270584106445 7.372055053710938 7.671660900115967 7.004084587097168 7.671660900115967 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.16734504699707 1.000000476837158 C 1.075074672698975 1.000000476837158 1.000004768371582 1.075090885162354 1.000004768371582 1.167380809783936 L 1.000004768371582 7.004280567169189 C 1.000004768371582 7.09657096862793 1.075074672698975 7.171660423278809 1.16734504699707 7.171660423278809 L 7.004084587097168 7.171660423278809 C 7.096354961395264 7.171660423278809 7.171424865722656 7.09657096862793 7.171424865722656 7.004280567169189 L 7.171424865722656 1.167380809783936 C 7.171424865722656 1.075090885162354 7.096354961395264 1.000000476837158 7.004084587097168 1.000000476837158 L 1.16734504699707 1.000000476837158 M 1.16734504699707 9.5367431640625e-07 L 7.004084587097168 9.5367431640625e-07 C 7.648794651031494 9.5367431640625e-07 8.171424865722656 0.5226507186889648 8.171424865722656 1.167380809783936 L 8.171424865722656 7.004280567169189 C 8.171424865722656 7.64901065826416 7.648794651031494 8.171660423278809 7.004084587097168 8.171660423278809 L 1.16734504699707 8.171660423278809 C 0.5226349830627441 8.171660423278809 4.76837158203125e-06 7.64901065826416 4.76837158203125e-06 7.004280567169189 L 4.76837158203125e-06 1.167380809783936 C 4.76837158203125e-06 0.5226507186889648 0.5226349830627441 9.5367431640625e-07 1.16734504699707 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2388",
    "data-name": "Rectangle 2388",
    transform: "translate(106 808.828)",
    fill: "#fff",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.171,
    height: 8.171,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7.171,
    height: 7.171,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2389",
    "data-name": "Rectangle 2389",
    transform: "translate(117.314 808.828)",
    fill: "#fff",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.171,
    height: 8.172,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 7.171,
    height: 7.172,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7271",
    "data-name": "Path 7271",
    d: "M11.369,0V1.565A1.655,1.655,0,0,1,9.707,3.2H1.662A1.655,1.655,0,0,1,0,1.565V0",
    transform: "translate(121.468 808.854) rotate(180)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7272",
    "data-name": "Path 7272",
    d: "M-5891.074,1740.431v3.141",
    transform: "translate(6006.724 -937.923)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6850",
    "data-name": "Rectangle 6850",
    width: 40,
    height: 40,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/Track.e1d1781bcc80569109f91a4e85a3548f.svg";
export { ForwardRef as ReactComponent };